import { IOption } from '@shared/interfaces';

export enum OperatorType {
  Equal = 'Equal',
  Greater = 'Greater',
  GreaterOrEqual = 'GreaterOrEqual',
  Less = 'Less',
  LessOrEqual = 'LessOrEqual',
  NotEqual = 'NotEqual',
}

export const OPERATOR_SYMBOL = {
  [OperatorType.Equal]: '=',
  [OperatorType.Greater]: '>',
  [OperatorType.GreaterOrEqual]: '>=',
  [OperatorType.Less]: '<',
  [OperatorType.LessOrEqual]: '<=',
  [OperatorType.NotEqual]: '≠',
};

export const operatorsList: IOption[] = [
  {
    value: OperatorType.Equal,
    label: OPERATOR_SYMBOL[OperatorType.Equal],
  },
  {
    value: OperatorType.Greater,
    label: OPERATOR_SYMBOL[OperatorType.Greater],
  },
  {
    value: OperatorType.GreaterOrEqual,
    label: OPERATOR_SYMBOL[OperatorType.GreaterOrEqual],
  },
  {
    value: OperatorType.Less,
    label: OPERATOR_SYMBOL[OperatorType.Less],
  },
  {
    value: OperatorType.LessOrEqual,
    label: OPERATOR_SYMBOL[OperatorType.LessOrEqual],
  },
  {
    value: OperatorType.NotEqual,
    label: OPERATOR_SYMBOL[OperatorType.NotEqual],
  },
];
